export type DemoListingCondition =
  | 'new_sealed'
  | 'unused'
  | 'excellent'
  | 'good'
  | 'fair'
  | 'damaged'

export type DemoListingTier = 'budget' | 'mid' | 'premium'

export type DemoListing = {
  id: string
  manufacturer: string
  model: string
  title: string
  description: string
  price: number
  condition: DemoListingCondition
  battery?: number
  seller: string
  location: string
  glyph: string
  gradient: string
  imeiMasked: string
  releaseYear?: number
}

export const DEMO_LISTINGS: DemoListing[] = [
  {
    id: 'd1',
    manufacturer: 'Samsung',
    model: 'Galaxy A05',
    title: 'Samsung Galaxy A05 — įkroviklis, dėklas',
    description:
      'Parduodu Samsung Galaxy A05 su originaliu įkrovikliu ir silikoniniu dėklu. Ekranas be įbrėžimų, veikia sklandžiai. Tinka kaip pirmas ar atsarginis telefonas.',
    price: 89,
    condition: 'good',
    battery: 94,
    seller: 'Mindaugas P.',
    location: 'Jonava',
    glyph: '■',
    gradient: 'linear-gradient(145deg, #1e293b 0%, #334155 45%, #0ea5e9 100%)',
    imeiMasked: '35******847',
    releaseYear: 2023,
  },
  {
    id: 'd2',
    manufacturer: 'Xiaomi',
    model: 'Redmi Note 13',
    title: 'Redmi Note 13 128 GB, puiki ekrano plėvelė',
    description:
      'Redmi Note 13 128 GB, visada naudota su stiklo plėvele. Baterija beveik kaip nauja, kamera ir ekranas be defektų. Komplekte dėžutė.',
    price: 159,
    condition: 'excellent',
    battery: 99,
    seller: 'MB „Mobilus kampelis"',
    location: 'Kaunas',
    glyph: '□',
    gradient: 'linear-gradient(145deg, #3a96a8 0%, #48a0b8 50%, #78d0d0 100%)',
    imeiMasked: '86******219',
    releaseYear: 2024,
  },
  {
    id: 'd3',
    manufacturer: 'Apple',
    model: 'iPhone SE (2022)',
    title: 'iPhone SE 2022 64 GB — naudotas darbe',
    description:
      'Kompaktiškas iPhone SE 2022, naudotas darbo reikmėms. Touch ID veikia, FaceTime ir LTE be problemų. Korpusas su normaliais naudojimo pėdsakais.',
    price: 235,
    condition: 'fair',
    battery: 81,
    seller: 'Ugnė K.',
    location: 'Vilnius',
    glyph: '△',
    gradient: 'linear-gradient(145deg, #0f172a 0%, #475569 60%, #f43f5e 100%)',
    imeiMasked: '35******512',
    releaseYear: 2022,
  },
  {
    id: 'd4',
    manufacturer: 'Google',
    model: 'Pixel 6',
    title: 'Pixel 6 — įskaitinis stiklas, veikia puikiai',
    description:
      'Google Pixel 6 su įskaitiniu priekiniu stiklu — vaizdas ir lietimui jautrus ekranas veikia puikiai. Kameros kokybė vis dar labai gera, Android atnaujinimai iki 2026.',
    price: 189,
    condition: 'damaged',
    battery: 87,
    seller: 'Tomas Š.',
    location: 'Klaipėda',
    glyph: '○',
    gradient: 'linear-gradient(145deg, #14532d 0%, #22c55e 55%, #fef08a 100%)',
    imeiMasked: '35******903',
    releaseYear: 2021,
  },
  {
    id: 'd5',
    manufacturer: 'Samsung',
    model: 'Galaxy S21 FE',
    title: 'Galaxy S21 FE 256 GB Snapdrag., originalus LCD',
    description:
      'Samsung Galaxy S21 FE 256 GB Snapdragon versija. Originalus ekranas, 120 Hz sklandus vaizdas. Idealus kasdieniam naudojimui ir nuotraukoms.',
    price: 319,
    condition: 'excellent',
    battery: 92,
    seller: 'Elektronika Lt shop',
    location: 'Panevėžys',
    glyph: '★',
    gradient: 'linear-gradient(145deg, #1e3a8a 0%, #2563eb 55%, #93c5fd 100%)',
    imeiMasked: '35******441',
    releaseYear: 2022,
  },
  {
    id: 'd6',
    manufacturer: 'Apple',
    model: 'iPhone 12',
    title: 'iPhone 12 128 GB — baterija keista 2025',
    description:
      'iPhone 12 128 GB, 2025 m. pakeista baterija — Health 100%. Be iCloud užrakto, Face ID ir True Tone veikia. Galiu parodyti IMEI ir testus vietoje.',
    price: 349,
    condition: 'good',
    battery: 100,
    seller: 'Julius R.',
    location: 'Šiauliai',
    glyph: '△',
    gradient: 'linear-gradient(145deg, #172554 0%, #3b82f6 50%, #e2e8f0 100%)',
    imeiMasked: '35******778',
    releaseYear: 2020,
  },
  {
    id: 'd7',
    manufacturer: 'OnePlus',
    model: 'Nord 3',
    title: 'OnePlus Nord 3 5G 256 GB, dual SIM',
    description:
      'OnePlus Nord 3 5G su greitu 80 W įkrovimu. 256 GB atmintis, dual SIM. Ekranas ryškus, našumas puikus žaidimams ir kasdienai.',
    price: 289,
    condition: 'good',
    battery: 91,
    seller: 'Greta V.',
    location: 'Kaunas',
    glyph: '|',
    gradient: 'linear-gradient(145deg, #7f1d1d 0%, #ef4444 45%, #fcd34d 100%)',
    imeiMasked: '86******334',
    releaseYear: 2023,
  },
  {
    id: 'd8',
    manufacturer: 'Samsung',
    model: 'Galaxy Z Flip4',
    title: 'Galaxy Z Flip4 — lengvas ekrano sulenkimo shade',
    description:
      'Samsung Galaxy Z Flip4 sulenkiamas flagmanas. Lengvas sulenkimo ekrano shade, mechanika veikia tvirtai. Unikalus formatas, patogu nešioti.',
    price: 479,
    condition: 'fair',
    battery: 88,
    seller: 'RetroPhones LT',
    location: 'Vilnius',
    glyph: '◇',
    gradient: 'linear-gradient(145deg, #4c1d95 0%, #a855f7 50%, #fbcfe8 100%)',
    imeiMasked: '35******662',
    releaseYear: 2022,
  },
  {
    id: 'd9',
    manufacturer: 'Apple',
    model: 'iPhone 13',
    title: 'iPhone 13 128 GB midnight, dėžutė',
    description:
      'iPhone 13 128 GB Midnight spalvos, su originalia dėžute. Ekranas be defektų, baterija vis dar labai gera kasdieniam naudojimui.',
    price: 459,
    condition: 'excellent',
    battery: 93,
    seller: 'Ieva M.',
    location: 'Palanga',
    glyph: '△',
    gradient: 'linear-gradient(145deg, #020617 0%, #1e293b 55%, #64748b 100%)',
    imeiMasked: '35******991',
    releaseYear: 2021,
  },
  {
    id: 'd10',
    manufacturer: 'Samsung',
    model: 'Galaxy S23',
    title: 'Galaxy S23 256 GB EU, garantija iki 2026',
    description:
      'Samsung Galaxy S23 256 GB EU versija, garantija galioja iki 2026 m. Kompaktiškas flagmanas, puiki kamera ir ekranas. Visi priedai vietoje.',
    price: 579,
    condition: 'excellent',
    battery: 97,
    seller: 'TechMart Baltic',
    location: 'Vilnius',
    glyph: '◆',
    gradient: 'linear-gradient(145deg, #0c4a6e 0%, #0284c7 40%, #bae6fd 100%)',
    imeiMasked: '35******120',
    releaseYear: 2023,
  },
  {
    id: 'd11',
    manufacturer: 'Apple',
    model: 'iPhone 14 Pro',
    title: 'iPhone 14 Pro 256 GB — akumuliatorius 90%',
    description:
      'iPhone 14 Pro 256 GB, Dynamic Island ir visada įjungtas ekranas veikia be priekaištų. Baterija ~90%, korpusas su nedideliais naudojimo pėdsakais.',
    price: 849,
    condition: 'good',
    battery: 90,
    seller: 'Arnas L.',
    location: 'Kaunas',
    glyph: '●',
    gradient: 'linear-gradient(145deg, #422006 0%, #92400e 40%, #fcd34d 100%)',
    imeiMasked: '35******455',
    releaseYear: 2022,
  },
  {
    id: 'd12',
    manufacturer: 'Apple',
    model: 'iPhone 15 Pro Max',
    title: 'iPhone 15 Pro Max 512 GB titanium blue',
    description:
      'iPhone 15 Pro Max 512 GB Titanium Blue. Naujausios kartos flagmanas, puiki kamera ir baterija. Idealus tiems, kam reikia didžiausio ekrano ir atminties.',
    price: 1189,
    condition: 'excellent',
    battery: 98,
    seller: 'Premium Mobile Vilnius',
    location: 'Vilnius',
    glyph: '◈',
    gradient: 'linear-gradient(145deg, #164e63 0%, #0891b2 45%, #e0f2fe 100%)',
    imeiMasked: '35******701',
    releaseYear: 2023,
  },
  {
    id: 'd13',
    manufacturer: 'Nothing',
    model: 'Phone (2)',
    title: 'Nothing Phone (2) 12/256 LED glyphs',
    description:
      'Nothing Phone (2) su unikaliu Glyph apšvietimu. 12 GB RAM, 256 GB atmintis. Android be nereikalingų programėlių, stilingas dizainas.',
    price: 419,
    condition: 'good',
    battery: 95,
    seller: 'Paulius Ž.',
    location: 'Marijampolė',
    glyph: '□',
    gradient: 'linear-gradient(145deg, #18181b 0%, #52525b 50%, #fafafa 100%)',
    imeiMasked: '86******188',
    releaseYear: 2023,
  },
  {
    id: 'd14',
    manufacturer: 'Sony',
    model: 'Xperia 1 IV',
    title: 'Sony Xperia 1 IV — fotografams, IP68',
    description:
      'Sony Xperia 1 IV profesionali kamera, 4K ekranas, IP68 apsauga. Tinka fotografams ir vaizdo įrašams. Visi mygtukai ir jungtys veikia.',
    price: 629,
    condition: 'fair',
    battery: 86,
    seller: 'FotoGear LT',
    location: 'Vilnius',
    glyph: '▷',
    gradient: 'linear-gradient(145deg, #1c1917 0%, #57534e 40%, #dc2626 100%)',
    imeiMasked: '35******366',
    releaseYear: 2022,
  },
  {
    id: 'd15',
    manufacturer: 'Motorola',
    model: 'Edge 40 Pro',
    title: 'Motorola Edge 40 Pro 256 GB, turbo įkrovimas',
    description:
      'Motorola Edge 40 Pro su itin greitu įkrovimu ir sklandžiu 165 Hz ekranu. 256 GB, švarus Android, puikus santykis kainos ir galios.',
    price: 379,
    condition: 'good',
    battery: 94,
    seller: 'Saulius D.',
    location: 'Telšiai',
    glyph: '↻',
    gradient: 'linear-gradient(145deg, #831843 0%, #db2777 45%, #fda4af 100%)',
    imeiMasked: '35******522',
    releaseYear: 2023,
  },
]

export function demoListingTier(price: number): DemoListingTier {
  if (price < 280) return 'budget'
  if (price < 650) return 'mid'
  return 'premium'
}

export function getDemoListing(id: string): DemoListing | undefined {
  return DEMO_LISTINGS.find((item) => item.id === id)
}

/** Extract hex colors from CSS linear-gradient for React Native LinearGradient. */
export function demoListingGradientColors(gradient: string): [string, string, string] {
  const matches = gradient.match(/#[0-9a-fA-F]{3,8}/g)
  if (!matches || matches.length < 2) return ['#1e293b', '#334155', '#0ea5e9']
  if (matches.length >= 3) return [matches[0], matches[1], matches[2]]
  return [matches[0], matches[1], matches[1]]
}
